<template>
  <div class="onLineShopListContainer">
    <div class="shopOutContentList">
      <div
        v-for="(item, index) in productsInfoList"
        :key="index"
        class="shopOutProduct"
        @click="goDetail(item.id)"
      >
        <div class="shopOutImg">
          <img
            :src="
              item.imgs.indexOf(',') >= 0 ? item.imgs.split(',')[0] : item.imgs
            "
            alt="图片加载失败"
          />
        </div>
        <div class="shopOutText">
          <div class="shopOutTextPrice">
            <span class="price">{{ Number(item.price).toFixed(2) }}</span>
            <span class="category">{{ item.category }}</span>
          </div>
          <span class="name" :title="item.name">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="shopPage">
      <el-pagination
        layout="prev, pager, next, total"
        :total="xiangmuTotal"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-size="productsInfoPageSize"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getProductsInfoList } from '../api/在线商城'

export default {
  mounted () {
    if (this.$route.query.shopTypeId) {
      this.type = this.$route.query.shopTypeId
    }
    this.getList()
  },
  data () {
    return {
      productsInfoList: [],
      productsInfoPageNum: 0,
      productsInfoPageSize: 12,
      xiangmuTotal: 0,
      type: "",
    }
  },
  methods: {
    currentChange (e) {
      this.productsInfoPageNum = e
      this.getList()
    },
    prevClick () {
      this.productsInfoPageNum--
      this.getList()
    },
    nextClick () {
      this.productsInfoPageNum++
      this.getList()
    },
    getList () {
      getProductsInfoList({
        pageSize: this.productsInfoPageSize,
        pageNum: this.productsInfoPageNum,
        type: this.type
      }).then(res => {
        this.productsInfoList = res.data.rows
        this.xiangmuTotal = res.data.total
      })
    },
    goDetail (id) {
      this.$router.push({
        path: '/onLineShopDetail',
        query: {
          id,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.onLineShopListContainer {
  width: 1824px;
  margin: 0 auto;
  min-height: 810px;
  background-color: #fff;
  padding: 30px 0;
  .shopOutContentList {
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-column-gap: 30px;
    padding: 30px 0;
    min-height: 360px;
    @keyframes boxShadow {
      to {
        box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.2);
      }
    }
    .shopOutProduct {
      height: 360px;
      width: 100%;
      box-shadow: 0px 0px 12px 0px rgba(21, 21, 21, 0.1);
      display: flex;
      flex-flow: column nowrap;
      cursor: pointer;
      margin-bottom: 30px;
      &:hover {
        animation: boxShadow 0.5s forwards;
      }
      .shopOutImg {
        height: 200px;
        width: 100%;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .shopOutText {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        flex: 1;
        padding: 28px;
        width: 100%;
        .shopOutTextPrice {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          width: 100%;
          height: auto;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 6px;
          .price {
            font-size: 24px;
            color: #f00;
            font-weight: 700;
            margin-right: 4px;
          }
          .category {
            color: #f00;
          }
        }
        .name {
          width: 223px;
          height: auto;
          font-size: 18px;
          color: rgb(96, 98, 102);
          max-lines: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .shopPage {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    justify-content: center;
  }
}
</style>